import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { isDefined } from '@grandvisionhq/utils';

// Value is empty because that way :invalid gets applied to the select when the placeholder is selected
const placeholderValue = '';
class Select extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return Object.entries(this.props).reduce((shouldUpdate, [propKey, currentPropValue])=>{
            const nextPropValue = nextProps[propKey];
            if (propKey === 'initialState') {
                const keys = Object.keys(nextProps.initialState || {});
                return keys.reduce((update, k)=>{
                    var ref, ref1;
                    return update || ((ref = nextProps.initialState) === null || ref === void 0 ? void 0 : ref[k]) === ((ref1 = this.props.initialState) === null || ref1 === void 0 ? void 0 : ref1[k]);
                }, true);
            } else {
                return shouldUpdate || nextPropValue === currentPropValue;
            }
        }, true);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.initialState !== this.props.initialState) {
            this.setState({
                selectedOptionKey: this.props.initialState && this.props.initialState.value,
                isTouched: this.props.initialState && this.props.initialState.isTouched
            });
        }
        if (prevState.selectedOptionKey !== this.state.selectedOptionKey) {
            var ref;
            const width = (ref = this.activeOptionRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
            this.setState({
                width
            });
        }
    }
    getOptions() {
        return this.props.sortOptionsBy ? Object.keys(this.props.options).sort(this.props.sortOptionsBy) : Object.keys(this.props.options);
    }
    render() {
        var ref, ref2;
        const _props = this.props, { id , name , label , className , placeholder , iconName , disabled , required =true , hideAsteriskSign =false , 'data-t': testId , renderInline  } = _props, rest = swcHelpers.objectWithoutProperties(_props, [
            "id",
            "name",
            "label",
            "className",
            "placeholder",
            "iconName",
            "disabled",
            "required",
            "hideAsteriskSign",
            'data-t',
            "renderInline"
        ]);
        var _width;
        const width = (_width = this.state.width) !== null && _width !== void 0 ? _width : (ref = this.activeOptionRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
        const activeOption = this.state.selectedOptionKey || ((ref2 = this.getOptions()) === null || ref2 === void 0 ? void 0 : ref2[0]);
        const shouldRenderInline = Boolean(renderInline && activeOption);
        const hiddenSelect = /*#__PURE__*/ React.createElement("span", {
            ref: this.activeOptionRef,
            className: "select-field__select-hidden",
            "aria-hidden": "true"
        }, activeOption);
        if (shouldRenderInline && !isDefined(width)) {
            return hiddenSelect;
        }
        var _selectedOptionKey;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames('select-field', className, {
                'select-field--disabled': disabled,
                'select-field--inline': renderInline
            })
        }, /*#__PURE__*/ React.createElement(OptionalSelectInlineContainer, {
            hiddenSelect: hiddenSelect,
            shouldRenderContainer: shouldRenderInline
        }, label && /*#__PURE__*/ React.createElement("label", {
            className: "select-field__label",
            htmlFor: id
        }, label, required && !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
            className: "select-field__asterisk"
        }, "*")), /*#__PURE__*/ React.createElement("div", {
            className: "select-field__select-wrapper"
        }, /*#__PURE__*/ React.createElement("select", swcHelpers.extends({
            id: id,
            name: name,
            className: "select-field__select",
            "data-t": testId,
            onChange: this.onChange,
            onFocus: this.onFocus,
            value: (_selectedOptionKey = this.state.selectedOptionKey) !== null && _selectedOptionKey !== void 0 ? _selectedOptionKey : placeholderValue,
            disabled: disabled,
            required: !!placeholder,
            "aria-label": this.props['aria-label'] || rest['aria-label'],
            "aria-labelledby": this.props['aria-labelledby'] || rest['aria-labelledby'],
            "aria-describedby": this.props['aria-describedby'] || rest['aria-describedby'],
            "aria-invalid": this.props['aria-invalid'] || rest['aria-invalid']
        }, renderInline && isDefined(width) && {
            style: {
                width
            }
        }), placeholder && /*#__PURE__*/ React.createElement("option", {
            "data-t": "select-placeholder",
            "aria-selected": "false",
            disabled: required,
            value: placeholderValue
        }, placeholder), this.getOptions().map((key)=>/*#__PURE__*/ React.createElement("option", {
                value: key,
                key: key,
                "aria-selected": this.state.selectedOptionKey === key
            }, key)
        )), /*#__PURE__*/ React.createElement(Icon, {
            name: iconName || 'chevron-down',
            className: "select-field__icon",
            "data-t": "select-field-icon"
        }))));
    }
    constructor(...args){
        super(...args);
        this.activeOptionRef = /*#__PURE__*/ React.createRef();
        this.state = {
            selectedOptionKey: this.props.initialState && this.props.initialState.value,
            isTouched: this.props.isTouched || false
        };
        this.onChange = (event)=>{
            const key = event.currentTarget.value;
            const value = this.props.options[key];
            this.props.onChange && value && this.props.onChange(value);
            this.setState({
                selectedOptionKey: key,
                isTouched: true
            });
        };
        this.onFocus = ()=>{
            if (this.props.selectionStart && !this.state.isTouched && !(this.props.initialState && this.props.initialState.value)) {
                var ref;
                const selectedOption = (ref = this.props.options) === null || ref === void 0 ? void 0 : ref[this.props.selectionStart];
                if (this.props.onChange && selectedOption !== undefined) {
                    this.props.onChange(selectedOption);
                    this.setState({
                        selectedOptionKey: this.props.selectionStart
                    });
                }
            }
        };
    }
}
const OptionalSelectInlineContainer = ({ hiddenSelect , shouldRenderContainer , children  })=>{
    if (!shouldRenderContainer) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, hiddenSelect, /*#__PURE__*/ React.createElement("div", {
        className: "select-field__inline-container"
    }, children));
};

export { Select as default };
//# sourceMappingURL=Select.js.map
